import { Header } from '@/components/header';
import type { HeaderItem } from '@/components/headerItems/types';

export const NEW_INQUIRY_TITLE = 'New Inquiry';

type NewInquiryHeaderProps = {
  isTabRoot: boolean;
  deleteDraftItem: HeaderItem;
};

/**
 * The native header for the general composer, in one of two shapes.
 *
 * As the Inquiry tab's root it is a top-level page like Directory, Inquiry Library and Inbox:
 * a large title and no back button, since there is nowhere in the tab to go back to. Opened over
 * another screen, such as a chat, it is a nested screen and keeps its back button.
 *
 * The trailing slot holds only the delete-draft item in both shapes. The composer leaves out the
 * invite and account items the other tabs carry, so nothing competes with the draft's own action.
 */
export function NewInquiryHeader({ isTabRoot, deleteDraftItem }: NewInquiryHeaderProps) {
  return (
    <Header
      title={NEW_INQUIRY_TITLE}
      rightItems={[deleteDraftItem]}
      contentScrollsUnderHeader
      isLarge={isTabRoot}
      isBackButton={!isTabRoot}
    />
  );
}
